var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentUuid)?_c('div',[_c('div',{staticClass:"mt-4 mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('DataTable',{ref:"datatable",attrs:{"type":"view","headers":_vm.selectedHeaders,"documentUuid":_vm.documentUuid}})],1)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }